__webpack_require__.p = "/assets/turbo/101bbf9c/quellede/_next/";